import { ReactElement } from "react";
import { useMunicipality } from "../../../Contexts/MunicipalityKey";
import { useAppSelector } from "../../../Hooks";

const simpleFooter = ["arendal"]; //Add more municipals here to enable simple footer
const extendedFooterMunicipalities = ["agderfk"];  // Municipalities with extended contact information

function Footer(): ReactElement {
  const municipality = useMunicipality();
  const footer = useAppSelector(state => state.config.config?.footer || undefined);


  return (
    <footer id="footer">
      {simpleFooter.includes(municipality.name) ? (
        <>
          <div className="simple container footer-container">
            <p>
              <a
                rel="noopener"
                target="_new"
                href={footer?.privacyStatementUrl}
              >
                Personvernerklæring
              </a>
              <br />
              {footer?.availabilityStatementUrl && (
                <a
                  rel="noopener"
                  target="_new"
                  href={footer?.availabilityStatementUrl}
                >
                  Tilgjengelighetserklæring
                </a>
              )}
            </p>
          </div>
        </>
      ) : extendedFooterMunicipalities.includes(municipality.name) ? (
          <div className="footer-extended">
            <div className="footer-section">
              <div className="footer-heading-group">
                <h2>Kontakt oss</h2>
                <div>
                  {footer?.servicedeskPhone && footer.servicedeskPhone !== "null" && (
                    <div className="contact-item">
                      Sentralbord: {footer.servicedeskPhone}
                    </div>
                  )}
                  {footer?.mainEmail && footer.mainEmail !== "null" && (
                    <div className="contact-item">
                      <a href={`mailto:${footer.mainEmail}`}>E-post til postmottak</a>
                    </div>
                  )}
                  <div className="contact-item">
                    <a
                      rel="noopener"
                      target="_new"
                      href={"https://agderfk.no/om-oss/kontakt-oss/send-henvendelser-og-dokumenter-pa-en-sikker-mate/"}
                    >
                      Send dokumenter til fylkeskommunen på en sikker måte
                    </a>
                  </div>
                   <div className="contact-item">
                    <a
                      rel="noopener"
                      target="_new"
                      href={"https://agderfk.no/om-oss/fakturering/"}
                    >
                      Fakturering
                    </a>
                  </div>
                  {footer?.postalAddress && footer.postalAddress.name && footer.postalAddress.name !== "null" && (
                    <div className="contact-item">
                      Postadresse:<br />
                      {footer.postalAddress.name}<br />
                      {footer.postalAddress.address && footer.postalAddress.address !== "null" && (
                        <>{footer.postalAddress.address}<br /></>
                      )}
                      {(footer.postalAddress.zipCode !== "null" || footer.postalAddress.city !== "null") && (
                        <>
                          {footer.postalAddress.zipCode && footer.postalAddress.zipCode !== "null" && (
                            <>{footer.postalAddress.zipCode}&nbsp;</>
                          )}
                          {footer.postalAddress.city && footer.postalAddress.city !== "null" && (
                            <>{footer.postalAddress.city}</>
                          )}
                        </>
                      )}
                    </div>
                  )}
                  {footer?.organisationNumber && footer.organisationNumber !== "null" && (
                    <div className="contact-item">
                      Organisasjonsnummer: {footer.organisationNumber}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="footer-section">
              <div className="footer-heading-group">
                <h2>Fylkeshuset i Agder, Kristiansand</h2>
                <div>
                  Besøks- og leveringsadresse:<br />
                  {footer?.visitingAddress && footer.visitingAddress.name && footer.visitingAddress.name !== "null" && (
                    <>{footer.visitingAddress.name}<br /></>
                  )}
                  {footer?.visitingAddress && footer.visitingAddress.address && footer.visitingAddress.address !== "null" && (
                    <>{footer.visitingAddress.address}<br /></>
                  )}
                  {footer?.visitingAddress && (
                    <>
                      {footer.visitingAddress.zipCode && footer.visitingAddress.zipCode !== "null" && (
                        <>{footer.visitingAddress.zipCode}&nbsp;</>
                      )}
                      {footer.visitingAddress.city && footer.visitingAddress.city !== "null" && (
                        <>{footer.visitingAddress.city}</>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="footer-section">
              <div className="footer-heading-group">
                <h2>Administrasjonsbygg i Arendal</h2>
                <div>
                  Besøks- og leveringsadresse:<br />
                  Agder fylkeskommune<br />
                  Ragnvald Blakstads vei 1<br />
                  4838 Arendal
                </div>
              </div>
            </div>
            <div className="footer-bottom-links">
              <a
                rel="noopener"
                target="_new"
                href={footer?.privacyStatementUrl}
              >
                Personvernerklæring
              </a>

              {footer?.availabilityStatementUrl && (
                <a
                  rel="noopener"
                  target="_new"
                  href={footer?.availabilityStatementUrl}
                >
                  Tilgjengelighetserklæring
                </a>
              )}
              
              {footer?.cookieStatementUrl && footer.cookieStatementUrl !== "null" && (
                <a rel="noopener" target="_new" href={footer.cookieStatementUrl}>
                  Informasjonskapsler
                </a>
              )}
            </div>
          </div>
      ) : (
        <>
          <h2 className="container">Kontakt oss</h2>
          <div className="container footer-container">
            {footer?.servicedeskPhone && footer.servicedeskPhone !== "null" && (
              <p>
                <strong>Sentralbord</strong>
                <br />
                <a href={"tel:" + footer.servicedeskPhone.replace(/\s/g, "")}> 
                  {footer.servicedeskPhone}
                </a>
              </p>
            )}
            <p>
              {footer?.mainEmail && footer.mainEmail !== "null" && (() => {
                return (
                  <a
                    rel="noopener"
                    target="_new"
                    href={`mailto:${footer.mainEmail}`}
                  >
                    Epost til kommunen
                  </a>
                );
              })()}
              {footer?.hidePostToMunicipality || (footer?.organisationNumber && footer.organisationNumber !== "null" && (
                <>
                  <br />
                  <a
                    rel="noopener"
                    target="_new"
                    href={`https://svarut.ks.no/edialog/mottaker/${footer.organisationNumber.replace(
                      /\s/g,
                      ""
                    )}`}
                  >
                    Send sikker digital post
                  </a>
                </>
              ))}
            </p>

            <p>
              {footer?.visitingAddress && footer.visitingAddress.name && footer.visitingAddress.name !== "null" && (
                <>
                  <strong>Besøksadresse</strong>
                  <br />
                  {footer.visitingAddress.name}
                  <br />
                  {footer.visitingAddress.address && footer.visitingAddress.address !== "null" && (
                    <>
                      {footer.visitingAddress.address}<br />
                    </>
                  )}
                  {(footer.visitingAddress.zipCode !== "null" || footer.visitingAddress.city !== "null") && (
                    <>
                      {footer.visitingAddress.zipCode && footer.visitingAddress.zipCode !== "null" && (
                        <>{footer.visitingAddress.zipCode}&nbsp;</>
                      )}
                      {footer.visitingAddress.city && footer.visitingAddress.city !== "null" && (
                        <>{footer.visitingAddress.city}</>
                      )}
                    </>
                  )}
                  <br />
                  {footer?.openingHoursUrl && footer.openingHoursUrl !== "null" && (
                    <a rel="noopener" target="_new" href={footer.openingHoursUrl}>
                      Åpningstider
                    </a>
                  )}
                </>
              )}
            </p>
            <p>
              {footer?.postalAddress && footer.postalAddress.name && footer.postalAddress.name !== "null" && (
                <>
                  <strong>Postadresse</strong>
                  <br />
                  {footer.postalAddress.name}
                  {footer.postalAddress.unit && footer.postalAddress.unit !== "" && footer.postalAddress.unit !== "null" && <br />}
                  {footer.postalAddress.unit && footer.postalAddress.unit !== "null" && footer.postalAddress.unit}
                  <br />
                  {footer.postalAddress.address && footer.postalAddress.address !== "null" && (
                    <>
                      {footer.postalAddress.address}<br />
                    </>
                  )}
                  {footer.postalAddress.zipCode && footer.postalAddress.zipCode !== "null" && (
                    <>
                      {footer.postalAddress.zipCode}&nbsp;
                    </>
                  )}
                  {footer.postalAddress.city && footer.postalAddress.city !== "null" && (
                    <>
                      {footer.postalAddress.city}
                    </>
                  )}
                </>
              )}
            </p>
            <p>
              {footer?.invoiceAddress && footer.invoiceAddress.name && footer.invoiceAddress.name !== "null" && (
                <>
                  <strong>Fakturaadresse</strong>
                  <br />
                  {footer.invoiceAddress.name}
                  <br />
                  {footer.invoiceAddress.address && footer.invoiceAddress.address !== "null" && (
                    <>
                      {footer.invoiceAddress.address}<br />
                    </>
                  )}
                  {footer.invoiceAddress.zipCode && footer.invoiceAddress.zipCode !== "null" && (
                    <>
                      {footer.invoiceAddress.zipCode}&nbsp;
                    </>
                  )}
                  {footer.invoiceAddress.city && footer.invoiceAddress.city !== "null" && (
                    <>
                      {footer.invoiceAddress.city}
                    </>
                  )}
                  <br />
                  {footer?.invoiceInfoUrl && footer.invoiceInfoUrl !== "null" && (
                    <a rel="noopener" target="_new" href={footer.invoiceInfoUrl}>
                      Faktura til kommunen - EHF
                    </a>
                  )}
                  <br />
                  {footer?.invoiceSupplierInfoUrl && footer.invoiceSupplierInfoUrl !== "null" && (
                    <a
                      rel="noopener"
                      target="_new"
                      href={footer.invoiceSupplierInfoUrl}
                    >
                      For leverandører
                    </a>
                  )}
                </>
              )}
            </p>
            <p>
              {footer?.organisationNumber && footer.organisationNumber !== "null" && (
                <>
                  <strong>Organisasjonsnummer</strong>
                  <br />
                  {footer.organisationNumber}
                  <br />
                </>
              )}
              {footer?.bankaccountNumber && footer.bankaccountNumber !== "null" && (
                <>
                  <strong>Bankkontonummer</strong>
                  <br />
                  {footer.bankaccountNumber}
                  <br />
                </>
              )}
              {footer?.municipalityNumber && footer.municipalityNumber !== "null" && (
                <>
                  <strong>Kommunenummer</strong>
                  <br />
                  {footer.municipalityNumber}
                  <br />
                </>
              )}
            </p>
            <p>
              <a
                rel="noopener"
                target="_new"
                href={footer?.privacyStatementUrl}
              >
                Personvernerklæring
              </a>

              {footer?.availabilityStatementUrl && (
                <>
                  <br />
                  <a
                    rel="noopener"
                    target="_new"
                    href={footer?.availabilityStatementUrl}
                  >
                    Tilgjengelighetserklæring
                  </a>
                </>
              )}
              <br />
              {footer?.cookieStatementUrl && footer.cookieStatementUrl !== "null" && (
                <>
                  <a rel="noopener" target="_new" href={footer.cookieStatementUrl}>
                    Informasjonskapsler
                  </a>
                  <br />
                </>
              )}
              {footer?.contactEmail && footer.contactEmail !== "null" && (
                <>
                  <a href={`mailto:${footer.contactEmail}`}>
                    Kontakt webredaksjonen
                  </a>
                </>
              )}
            </p>
          </div>
        </>
      )}
    </footer>
  );
}
export default Footer;
